import { render, staticRenderFns } from "./OperationDetail.vue?vue&type=template&id=fcff54b8&"
import script from "./OperationDetail.vue?vue&type=script&lang=js&"
export * from "./OperationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports